/** Internal dependencies */
import { prepareApiCall } from './prepareApiCall';

export function prepareSearch(searchFilter) {
    // check for change events on the input and click events on the submit button
    const searchInput = searchFilter.querySelector('input[type="search"]');
    const searchSubmit = searchFilter.querySelector('[data-filter-search-submit]');

    if (searchInput) {
        searchInput.addEventListener('keyup', handleSearchInput);
    }

    if (searchSubmit) {
        searchSubmit.addEventListener('click', handleSearchSubmit);
    }
}

function handleSearchInput(e) {
    const input = e.target;

    if (input.value === '' || input.value.length >= 3) {
        const parent = input.closest('[data-rest]');
        prepareApiCall(parent);
    }
}

function handleSearchSubmit(e) {
    e.preventDefault();
    const parent = e.target.closest('[data-rest]');
    prepareApiCall(parent);
}
